import { createStore } from "vuex";
import Editcopy from "../pages/Editcopy/store/store";
import user from "./user";
import powersuite from "./powersuite";
import GenerativeTexts from "./generativetexts.js";
import Templates from "./templates.js";

export default createStore({
	modules: {
		user,
		Editcopy,
		powersuite,
		GenerativeTexts,
		Templates,
	}
});
